import { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Grid, Typography } from "@mui/material";
import FilterBtn from "../../../../../Assets/Icons/btn-filters.png";
import FilterBtnUp from "../../../../../Assets/Icons/btn-filters-up.png";
import CustomLoadingOverlay from "../../../../../Components/CustomLoadingOverlay";
import { cleanFilterData } from "../../../../../Utils/FilterUtils";
import { usePickerReport } from "./usePickerReport";
import { getColumns } from "./columns";
import Filter from "./Filter";

const INITIAL_FILTER_STATE = {
  picker_id: "",
  start_date: null,
  end_date: null,
  category_id: "",
};

const PickerReport = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(INITIAL_FILTER_STATE);
  const [submittedData, setSubmittedData] = useState({});
  const { reportData, pickers, categories, loading, error, fetchReportData } =
    usePickerReport({
      autoFetch: true,
    });

  const columns = getColumns();

  const handleChangeFilter = (field) => (event, value) => {
    if (
      field.includes("Date") ||
      field.includes("start") ||
      field.includes("end")
    ) {
      setFilterData((prev) => ({
        ...prev,
        [field]: value || (event && event.target.value) || null,
      }));
      return;
    }

    setFilterData((prev) => ({
      ...prev,
      [field]: value || (event && event.target.value) || "",
    }));
  };

  const handleFilter = (filterData) => {
    const cleanedData = cleanFilterData(filterData);
    setSubmittedData(cleanedData);
    fetchReportData(filterData);
  };

  const onFilterClick = () => {
    handleFilter(filterData);
  };

  const handleRemove = (field) => {
    const newFilterData = { ...filterData };
    const newSubmittedData = { ...submittedData };

    newFilterData[field] =
      field.includes("start") || field.includes("end") ? null : "";
    delete newSubmittedData[field];
    setFilterData(newFilterData);
    setSubmittedData(newSubmittedData);

    handleFilter(newFilterData);
  };

  const handleClearFilters = () => {
    setFilterData(INITIAL_FILTER_STATE);
    setSubmittedData({});
    handleFilter(INITIAL_FILTER_STATE);
  };

  if (error) {
    return (
      <Box sx={{ width: "100%", padding: 2 }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            backgroundColor: "#fff",
            padding: "24px 16px",
            borderRadius: "8px",
          }}
        >
          <div>Error: {error}</div>
          <button onClick={fetchReportData}>Retry</button>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          backgroundColor: "#fff",
          padding: "24px 16px",
          borderRadius: "8px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Picker Report
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={filterOpen ? FilterBtnUp : FilterBtn}
              alt="Filter"
              style={{ cursor: "pointer" }}
              onClick={() => setFilterOpen(!filterOpen)}
            />
          </Box>
        </Box>

        <Filter
          filterOpen={filterOpen}
          filterData={filterData}
          handleChangeFilter={handleChangeFilter}
          handleFilter={onFilterClick}
          handleClearFilters={handleClearFilters}
          handleRemove={handleRemove}
          submittedData={submittedData}
          pickers={pickers}
          categories={categories}
        />

        <DataGrid
          rows={reportData}
          columns={columns}
          autoHeight
          disableRowSelectionOnClick
          loading={loading}
          slots={{
            loadingOverlay: CustomLoadingOverlay,
          }}
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "14px",
              fontWeight: 500,
              color: "#48505E",
            },
          }}
          getRowId={(row) => row.syncCareAssignedPickerId}
        />
      </Box>
    </Box>
  );
};

export default PickerReport;
